import "./index.css";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";

import CalendarPicker from "../CalendarPicker";

const ChatToolbar = ({ selectedDate, setSelectedDate }) => {
  const { user, logOut } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleSignOut = async () => {
    await logOut();
  };

  return (
    <div className="chat-toolbar">
      <div className="chat-toolbar-container">
        <CalendarPicker
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
        <div className="user-dropdown" onClick={() => setDropdownOpen(!dropdownOpen)}>
          <img className="user-avatar" src={user ? user.photoURL : ""} alt="profile-pic" />
          {dropdownOpen && (
            <div className="dropdown">
              <div className="sign-out-btn" onClick={handleSignOut}>
                <i className="fa fa-sign-out" />Logout
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatToolbar;
